import enviro from 'enviro';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { NavMarker } from 'react-rhumb';
import { Flow } from 'signup-constants/Flow';
import ViralLink from 'viral-links-lib/viral-link/ViralLink';
import { getFormsQueryParams, getPortalIdFromUrl } from '../utils/urls';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Forms() {
  const portalId = getPortalIdFromUrl();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FORMS_LINK_LOADED",
    children: /*#__PURE__*/_jsx(ViralLink, {
      portalId: portalId || undefined,
      use: "primary",
      environment: enviro.getShort(),
      flow: Flow.Marketing,
      viralLinkType: "forms",
      iconSize: "700",
      typography: 'body-125',
      additionalParams: getFormsQueryParams(),
      children: /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "app.viralLinks.forms.linkCta"
        })
      })
    })
  });
}